export default "__VITE_ASSET__Dl2kU6FC__"